<template>
  <div class="index_home">

    <IndxHead></IndxHead>
    <div class="w100" style="height: 800px;">
      <section class="fourNm">


        <h1 style="color: #286041; font-size: 50px; ">新能源·新发展·新未来</h1>
        <p style="color: #387754;font-size: 20px;">为绿色低碳转型注入持久动力</p>



      </section>

    </div>
    <div>
      <!--  -->

      <section id="one" class="eduBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">新能源</h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">new energy</p>
        </div>

        <div class="w1024">
          <div class="pt-50 color-2" style="line-height: 2;text-align: left;">

            <p style="color: #34497d; font-weight: bold; "> 通过自主创新，掌握核心设计、制造技术
              并形成规模化生产的高科技企业</p>
            <p style="margin-top: 10px;"><img :src="ddt" alt="" class="imgs1">完成了该领域国内第一个863（国家重
              点研发计划)项目。</p>
            <p><img :src="ddt" alt="" class="imgs1">开发了国内第一台SOFC独立发电系统。</p>
            <p><img :src="ddt" alt="" class="imgs1">构建了国内领尖的燃料电池研究开发平台。</p>
            <p style="color: #34497d; font-weight: bold; margin-top: 30px;">所获荣誉</p>
            <ul style="margin-top: 10px;">

              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">武汉市科技小巨人企业</span><img :src="rt"
                  alt="" class="imgs"></li>
              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">高新技术企业</span><img :src="rt" alt=""
                  class="imgs"></li>
              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">湖北省创新型中小企业</span><img :src="rt"
                  alt="" class="imgs"></li>
              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">科创中国先导技术榜单</span><img :src="rt"
                  alt="" class="imgs"></li>
              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">光谷瞪羚企业</span><img :src="rt" alt=""
                  class="imgs"></li>
              <li class="flex2"><img :src="lf" alt="" class="imgs"><span class="lf10">日内瓦国际发明展金奖</span><img :src="rt"
                  alt="" class="imgs"></li>
            </ul>
          </div>
          <!-- <img :src="img2" alt="" class="img1"> -->
        </div>
       
      </section>


      <!--  -->
      <section id="two" class="hgBox">
        <div>
          <h1 class="pt-100 color-fff" style="font-size: 30px;padding-top: 190px;">新材料</h1>
          <p class="line-block" style="margin:auto;background-color: #ffffff;"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #ffffff;margin-top: 10px;">New materials
          </p>
        </div>
        <div class="w1024" style="position: relative;">
          <div class="pt-50 color-fff d-flex" style="line-height: 2;padding-top:100px;justify-content: space-between;">


            <div style="width: 500px;padding: 30px;background: rgba(255, 255, 255, 0.2);border-radius: 10px;">
              <h3 style="margin-bottom: 20px;border-bottom: 1px solid rgba(255, 255, 255, 0.4);padding-bottom: 20px;">
                煤矸石的物理化学特性</h3>
              <p style="text-align: left;">
                煤矸石是煤炭开采过程中的伴生物，主要是硅、铝等成分，占煤炭开采总量的10-20%。煤矸石具有低发热值、含腐殖酸等特点，具有多领域应用潜力，但工业化处理难题较多，长期被视为大宗固废。

              </p>
            </div>


            <div style="width: 500px;padding: 30px;background: rgba(255, 255, 255, 0.2);border-radius: 10px;">
              <h3 style="margin-bottom: 20px;border-bottom: 1px solid rgba(255, 255, 255, 0.4);padding-bottom: 20px;">
                煤矸石的物理化学特性</h3>
              <p style="text-align: left;">长期堆积易蓄热燃烧，产生SO₂、CO、H₂S等有害气体，危害人体健康，少量吸入可致命。
                经雨水冲刷后，有害物质流向耕田、树林，严重威胁农作物、树木生长，污染土地和水资源。
              </p>
            </div>

          </div>

          <div style="position:absolute;bottom: -180px; left: 40%;">
            
            <img :src="img6" alt="" style="width: 250px; ">
          </div>

        </div>
      </section>
      <!--  -->


      <section  id="thress" class="aiBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">矿业 </h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">mining industry

          </p>
        </div>
        <div class="w1024">
          <div class="pt-50 color-2" style="line-height: 2;text-align: left;">
            <i
              style="background: #4c84c5;font-style: normal; color: #ffffff; padding: 10px 30px; border-top-right-radius: 80px; border-bottom-right-radius: 80px;">公司注册与资本</i>
            <p style="margin-top: 10px;">罗田县德信矿业发展有限公司成立于2010年1月7日，注册资本1000
              万元。公司专注于矿业领域，致力于石英石的开采、加工及产业化。</p>
            <i
              style="margin-top: 20px;display: inline-block; background: #4c84c5;font-style: normal; color: #ffffff; padding: 10px 30px; border-top-right-radius: 80px; border-bottom-right-radius: 80px;">核心业务定位</i>
            <p style=" margin-top: 10px;margin-top: 20px;">公司的核心业务是石英石的开采与深加工，打造石英石全产业链，推
              动行业技术进步和产业发展。通过专业化运营，为市场提供高品质的
              石英产品。</p>
            <i
              style="margin-top: 20px;display: inline-block; background: #4c84c5;font-style: normal; color: #ffffff; padding: 10px 30px; border-top-right-radius: 80px; border-bottom-right-radius: 80px;">未来发展基础</i>
            <p style="margin-top: 10px;">公司凭借多年积累的行业经验和技术优势，积极整合石英石资源，不
              断丰富硅基新材产品系列，充分利用资本力量扩大产能规模，提升公
              司的行业地位</p>
          </div>

        </div>
      </section>
      <!--  -->

      <section id="four" class="gyBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">新科技 </h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">New Technology
          </p>
        </div>
         <div class="w1024">
          <div class="pt-50 color-2" style="line-height: 2;text-align: left;">
           
           <div style="width: 770px;">

            武汉长光科技有限公司（下称长光科技）于2006年由长飞光纤光缆股份有限公司(601869/06869)、武汉长江通信产业集团 
            股份有限公司(600345)等联合发起设立的一家专业致力于光纤通信端到端接入与运营服务商。 
            2016年长光科技实施股权重组方案，形成多元化股权构架。长光科技注册资本17,728万元，地处中国光谷核心区。  <br> 
            长光科技以“让全世界人民都能享受FTTX带来的自由和快乐”为使命，专注于光纤通信的技术研发及网络运营服务，是中国光纤通信的先行者， 
            创立之初便跻身光纤通信行业第一梯队。长光科技将研发和技术创新作为立足之本，主持完成了 
            三项国家“863”重大科研课题和国家发改委重大产业化专项，以及四十余项省市区研发和产业化项目，取得了近百项发明专利等科研成果，是 
            国家工程实验室、国家专精特新“小巨人”企业、国家级“优秀高新技术企业”、“国家知识产权示范企业”、 
            “湖北省认定企业技术中心”、光谷上市“金种子”企业，
            获得”湖北省科学技术发明奖一等奖“等奖项。 长光科技秉承”让数据传输更快“的技术发展理念，
            研发出超高速DWDM 200G 
            PON技术，一跃填补国际空白。其车载光通信技术更具划时代意义，不仅引领行业技术进步，而且驱动智能汽车产业升级。  <br>
            长光科技顺应国家”一带一路“战略，带头参与沿线国家的数字基础设施建设， 
            项目在东南亚、非洲等多个国家落地，用先进的通信技术和科研成果带动了当地社会和经济发展。 

           </div> 
          </div>

        </div>
      </section>

      <!--  -->

      <section>

        <IndxFoot></IndxFoot>
      </section>
    </div>
  </div>
</template>

<script>
import img1 from '../images/ip111.png'
import img2 from '../images/ip22.png'

import img6 from '../images/h1.png'



import lf from '../images/lf.png'
import rt from '../images/rt.png'
import ddt from '../images/ddt.png'




import IndxHead from '@/components/IndxHead.vue'
import IndxFoot from '@/components/IndxFoot.vue'

export default {
  name: 'HomePage',
  components: {
    IndxHead,
    IndxFoot,

  },
  data() {
    return {source: [{
        titele: "新矿产资源法的十大亮点", date: '02-08',text:'矿产资源是工业的粮食和血液，是经济社会发展的重要物质基础。随着工业化、城镇化的快速推进，我国对矿产资源的需求和消耗日益增大。同时，随着绿色低碳革命在全球的推进', url:'https://www.gov.cn/lianbo/bumen/202411/content_6986009.htm'
      },
      { titele: '新修订的《中华人民共和国矿产资源法》 ', text:'(1986年3月19日第六届全国人民代表大会常务委员会第十五次会议通过  根据1996年8月29日第八届全国人民代表大会常务委员会第二十一次会议《关于修改〈中华人民共和国矿产资源法〉的决定》',date: '05-09' ,url:'http://www.gsht.gov.cn/zfxxgk/bmxzxxgk/xzxxgk/htssyxrmzf/fdzdgknr/YJGL/art/2025/art_a0971c70db614319b7f3c5b00e68c2d2.html'},
      { titele: '新能源2035年目标：风光装机容量迈向36亿千瓦 ', text:'截至2024年底，全国风电、光伏装机容量已达13.5亿千瓦，提前6年完成《巴黎协定》设定的2030年目标。而2035年36亿千瓦的装机容量，相当于在现有基础上再造两个半“中国电网”，其规模超过美国、欧盟、印度三大经济体总和。',date: '06-29',url:'https://xueqiu.com/1438272693/354635779' },
      { titele: '“十五五”规划（2026-2030年）核心内容解析 ',text:'“十五五”规划是我国迈向2035年基本实现社会主义现代化目标的关键五年规划，其核心内容围绕“高质量发展”主线，聚焦“科技自立自强”“产业升级”“内需扩大”“安全保障”四大维度，旨在通过系统性部署破解发展难题、增强发展动力、厚植发展优势。',date: '06-19',url:"http://www.360doc6.net/wxarticlenew/1163849574.html"},
      { titele: 'A股三大股指尾盘下跌，摩尔线程猛涨28%市值破4400亿，加密货币全线杀跌15万人爆仓', text:'12月11日午后，亚太股市呈现“先扬后抑”的剧烈反转，截至收盘日韩股市集体收跌，A股三大股指尾盘也加速下跌，创业板指、深证成指均跌超1%，沪指跌0.7%，全市场超4300只个股下跌。泛消费、房地产、纺织服装、食品饮料等方向跌幅居前。', date: '07-26',url:'https://www.21jingji.com/article/20251211/herald/29973b6d31bfbc3b90ecec1bd09f43de.html' },
      { titele: '兴业证券：氢能市场前景和生态价值广阔 推荐绿色甲醇生产环节   ', text:'兴业证券发布研报称，氢能在十五五期间走向规模化的规划更加清晰。同时展现出广阔的市场前景和生态价值，但是具备经济性、可持续性的商业模式仍是',date: '08-22',url:"https://finance.sina.com.cn/stock/hkstock/ggscyd/2025-12-05/doc-infzttzy9885006.shtml" },
      { titele: 'OpenAI会是第一个倒闭的AI独角兽吗？ ',text:'11月20日，Gemini3推出两天后，在被称为“硅谷投资人春晚”的Cerebral Valley AI峰会上，OpenAI就被选成了“第二大可能倒闭的AI独角兽”。', date: '08-25',url:"https://finance.sina.com.cn/tech/internet/2025-12-07/doc-infzxvsr3004349.shtml" },
      { titele: '好生意的故事，给投资带来的启发：', text:'一位茶商，祖上就经营云南的古树生普，他家的恒温存茶的库房，一进去，满屋茶砖茶饼，茶香四溢。现在库房里还存有上世纪60年代的普洱茶，而这些普洱茶当年的收购价1斤竟然不到1元钱',date: '09-28',url:'https://xueqiu.com/1176935028/360177531' },
      ],
      img1: img1,
      img2: img2,
      lf: lf,
      rt: rt,
      ddt: ddt,
      img6: img6
    }
  },
  mounted() {
    this.scrollToSection();
  },
  beforeUnmount() {

  },
  methods: {
    scrollToSection() {
      // 在下一个tick执行，确保DOM已经渲染完成
      this.$nextTick(() => {
        const section = this.$route.query.section;
        if (section) {
          // 延迟执行，确保页面完全加载
          setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
              // 计算导航栏高度，确保滚动位置正确
              const headerHeight = 80; // 根据您的导航栏高度调整
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }, 300);
        }
      });
    },
    //
  },
  watch: {
    // 监听路由参数变化，当参数变化时重新滚动
    '$route.query.section': {
      handler(newVal) {
        if (newVal) {
          this.scrollToSection();
        }
      },
      immediate: false
    }
  }
}
</script>

<style scoped>
.lf10 {
  padding-left: 4px;
  padding-right: 4px;
}

.flex2 {
  display: flex;
  align-items: center;
}

.imgs {
  width: 8px;
  height: 18px;

}

.imgs1 {
  width: 14px;
  margin-right: 6px;

}

#education,
#agriculture {
  scroll-margin-top: 80px;
  /* 根据导航栏高度调整 */
}

.img1 {
  width: 700px;
  mix-blend-mode: multiply;
  margin-top: 20px;
}


.img2 {
  width: 700px;
  mix-blend-mode: multiply;
  margin-top: 20px;
  position: relative;
  left: 220px;
}

.eduBox {
  background: url(/src/images/vv4.jpg) no-repeat;
  background-size: cover;
  height: 700px;
  width: 100%;
}

.hgBox {
  background: url(/src/images/vv2.jpg) no-repeat;
  background-size: cover;
  height: 800px;
  width: 100%;
}

.aiBox {
  background: url(/src/images/vv3.png) no-repeat;
  background-size: cover;
  height: 700px;
  width: 100%;
}

.gyBox {
  background: url(/src/images/vv1.jpg) no-repeat;
  background-size: cover;
  height: 760px;
  width: 100%;
}

.fourNm {
  width: 100%;
  height: 100%;
  background: url(../images/xx.jpg) no-repeat;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  flex-direction: column;
}

/* 中心点 */
.center {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #3498db;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  z-index: 10;
  position: relative;
}

/* 波纹容器 */
.ripple {
  width: 250px;
  height: 250px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* 波纹层 */
.wave {
  position: absolute;
  border-radius: 50%;
  border: 2px solid #3498db;
  animation: ripple 2s linear infinite;
}

/* 第四个圆圈 - 双层快速波纹 */
.ripple-4 .wave {
  border-color: #f39c12;
  animation-duration: 1s;
}

.ripple-4 .center {
  background: #f39c12;
}

.ripple-4 .wave:nth-child(2) {
  animation-delay: 0s;
}

.ripple-4 .wave:nth-child(3) {
  animation-delay: 0.9s;
}

/* 波纹动画 */
@keyframes ripple {
  0% {
    width: 80px;
    height: 80px;
    opacity: 1;
  }

  100% {
    width: 120px;
    height: 120px;
    opacity: 0;
  }
}
</style>